<template>
  <svg
    viewBox="0 0 278 150"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="none"
      fill-rule="evenodd"
    >
      <path
        d="m236.46 2.68 6 10.39c.16.26.27.54.36.81 1 .05 1.99.22 2.94.51l23.73 7.2A12 12 0 0 1 278 33.09V114a12 12 0 0 1-8.24 11.39l-23.82 7.87a12 12 0 0 1-2.55.54l-5.93 10.26a4 4 0 0 1-6.92-4l3.57-6.2H12a12 12 0 0 1-12-11.7v-96.3a12 12 0 0 1 12-12h221.69l-4.15-7.2a4 4 0 0 1 6.92-4zm5.82 19.2H12a4 4 0 0 0-4 4v96a4 4 0 0 0 4 4h230.18a4 4 0 0 0 1.25-.21l23.82-7.87A4 4 0 0 0 270 114V33.08a4 4 0 0 0-2.84-3.83l-23.72-7.2a4 4 0 0 0-1.16-.18z"
        fill-rule="nonzero"
        fill="currentColor"
      />
      <path
        d="M35 43h4v62h-4zm14 0h4v62h-4z"
        fill="currentColor"
      />
      <path
        d="M39 72v4H7v-4z"
        fill="currentColor"
      />
      <path
        d="M6 43h119a4 4 0 0 1 4 4v54a4 4 0 0 1-4 4H6V43z"
        stroke="currentColor"
        stroke-width="4"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>
